import { defineMessages } from 'react-intl'

export const ProgramDisplayLabels = defineMessages({
  therapy: {
    defaultMessage: 'Therapy',
    description: "Generic display label for Lyra's Therapy program.",
  },
  teensTherapy: {
    defaultMessage: 'Teens Therapy',
    description: "Display label for Lyra's Teens Therapy program.",
  },
  coaching: {
    defaultMessage: 'Coaching',
    description: "Generic display label for Lyra's Coaching program.",
  },
  coachingForParents: {
    defaultMessage: 'Coaching for Parents',
    description: "Display label for Lyra's Coaching for Parents program.",
  },
  guidedSelfCare: {
    defaultMessage: 'Guided Self-Care',
    description: "Display label for Lyra's Guided Self-Care program.",
  },
  medicationManagement: {
    defaultMessage: 'Medication Management',
    description: "Display label for Lyra's Medication Management program.",
  },
  renew: {
    defaultMessage: 'Renew',
    description: "Display label for Lyra's Alcohol Use Disorder Therapy (Renew) program.",
  },
  dialecticalBehaviorTherapy: {
    defaultMessage: 'Dialectical Behavior Therapy',
    description: "Display label for Lyra's Dialectical Behavior Therapy program.",
  },
  clinicalLeaveEvaluation: {
    defaultMessage: 'Clinical Leave Evaluation',
    description: "Display label for Lyra's Clinical Leave Evaluation offering.",
  },
  couplesTherapy: {
    defaultMessage: 'Couples Therapy',
    description: "Display label for Lyra's Couples Therapy program.",
  },
  familyTherapy: {
    defaultMessage: 'Family Therapy',
    description: "Display label for Lyra's Family Therapy program.",
  },
  adolescentTherapy: {
    defaultMessage: 'Adolescent Therapy',
    description: "Display label for Lyra's Adolescent Therapy program.",
  },
  childTherapy: {
    defaultMessage: 'Child Therapy',
    description: "Display label for Lyra's Child Therapy program.",
  },
  lyraCommunityMedications: {
    defaultMessage: 'Lyra Community Medications',
    description: "Display label for Lyra's Lyra Community Medications program.",
  },
  lyraCommunityTherapy: {
    defaultMessage: 'Lyra Community Therapy',
    description: "Display label for Lyra's Lyra Community Therapy program.",
  },
  performanceCoaching: {
    defaultMessage: 'Performance Coaching',
    description: "Display label for Lyra's Performance Coaching program (Google Catalyst v2).",
  },
  neurodiversitySkillsCoaching: {
    defaultMessage: 'Neurodiversity Skills Coaching',
    description: "Display label for Lyra's Neurodiversity Skills Coaching program.",
  },
  caregiverTrainingForNeuro: {
    defaultMessage: 'Caregiver Training for Neurodiversity',
    description: "Display label for Lyra's Caregiver Training for Neurodiversity program.",
  },
})

export const ConsentText = defineMessages({
  alcoholUseDisorderConsent: {
    defaultMessage: 'AUD Consent',
    description:
      "Link to a user consent agreement for users participating in Lyra's program encompassing Alcohol Use Disorder (AUD).",
  },
  dialecticalBehaviorTherapyConsent: {
    defaultMessage: 'Dialectical Behavior Therapy Consent',
    description:
      "Link to a user consent agreement for users participating in Lyra's Dialectical Behavior Therapy program.",
  },
  coachingConsent: {
    defaultMessage: 'Coaching Consent',
    description: "Link to a user consent agreement for users participating in Lyra's Blended Care Coaching program.",
  },
  guidedSelfCareConsent: {
    defaultMessage: 'Guided Self-Care Consent',
    description: "Link to a user consent agreement for users participating in Lyra's Guided Self-Care program.",
  },
  medicationManagementConsent: {
    defaultMessage: 'Medication Management Consent',
    description: "Link to a user consent agreement for users participating in Lyra's Medication Management program.",
  },
  therapyConsent: {
    defaultMessage: 'Therapy Consent',
    description: "Link to a user consent agreement for users participating in Lyra's Blended Care Therapy program.",
  },
  neurodiversitySkillsCoachingConsent: {
    defaultMessage: 'Neurodiversity Skills Coaching Consent',
    description:
      "Link to a user consent agreement for users participating in Lyra's Neurodiversity Skills Coaching program.",
  },
  caregiverTrainingForNeuroConsent: {
    defaultMessage: 'Caregiver Training for Neurodiversity Consent',
    description:
      "Link to a user consent agreement for users participating in Lyra's Caregiver Training for Neurodiversity program.",
  },
})
